export class IbanValidator {
  static COUNTRY_IBAN_REGEX = {
    'Austria': '^[AT]{2}[0-9]{2}[0-9]{5}[0-9]{11}$',
    'Belgium': '^[BE]{2}[0-9]{2}[0-9]{4}[0-9]{4}[0-9]{4}$',
    'Bulgaria': '^[BG]{2}[0-9]{2}[A-Z]{4}[0-9]{6}[0-9]{8}$',
    'Croatia': '^[HR]{2}[0-9]{2}[0-9]{7}[0-9]{10}$',
    'Cyprus': '^[CY]{2}[0-9]{2}[0-9]{3}[0-9]{5}[0-9]{16}$',
    'Czech Republic': '^[CZ]{2}[0-9]{2}[0-9]{4}[0-9]{6}[0-9]{10}$',
    'Denmark': '^[DK]{2}[0-9]{2}[0-9]{4}[0-9]{10}$',
    'Estonia': '^[EE]{2}[0-9]{2}[0-9]{2}[0-9]{2}[0-9]{12}$',
    'Finland': '^[FI]{2}[0-9]{2}[0-9]{6}[0-9]{8}$',
    'France': '^[FR]{2}[0-9]{2}[0-9]{5}[0-9]{5}[0-9]{13}$',
    'Germany': '^[DE]{2}[0-9]{2}[0-9]{8}[0-9]{10}$',
    'Greece': '^[GR]{2}[0-9]{2}[0-9]{3}[0-9]{4}[0-9]{16}$',
    'Hungary': '^[HU]{2}[0-9]{2}[0-9]{3}[0-9]{4}[0-9]{17}$',
    'Ireland': '^[IE]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{7}([a-zA-Z0-9]?){0,16}$',
    'Italy': '^[IT]{2}[0-9]{2}[a-zA-Z0-9]{1}[0-9]{5}[0-9]{5}[0-9]{12}$',
    'Latvia': '^[LV]{2}[0-9]{2}[A-Z]{4}[0-9]{4}[0-9]{9}$',
    'Lithuania': '^[LT]{2}[0-9]{2}[0-9]{5}[0-9]{11}$',
    'Luxembourg': '^[LU]{2}[0-9]{2}[0-9]{3}[0-9]{13}$',
    'Malta': '^[MT]{2}[0-9]{2}[A-Z]{4}[0-9]{12}[a-zA-Z0-9]{11}$',
    'Netherlands': '^[NL]{2}[0-9]{2}[a-zA-Z0-9]{4}[0-9]{10}$',
    'Poland': '^[PL]{2}[0-9]{2}[0-9]{8}[0-9]{16}$',
    'Portugal': '^[PT]{2}[0-9]{2}[0-9]{4}[0-9]{4}[0-9]{13}$',
    'Romania': '^[RO]{2}[0-9]{2}[A-Z]{4}[0-9]{16}$',
    'Slovakia': '^[SK]{2}[0-9]{2}[0-9]{4}[0-9]{6}[0-9]{10}$',
    'Slovenia': '^[SI]{2}[0-9]{2}[0-9]{4}[0-9]{4}[0-9]{7}$',
    'Spain': '^[ES]{2}[0-9]{2}[0-9]{4}[0-9]{4}[0-9]{1}[0-9]{1}[0-9]{10}$',
    'Sweden': '^[SE]{2}[0-9]{2}[0-9]{4}[0-9]{4}[0-9]{1}[0-9]{1}[0-9]{10}$'
  }

  static ibanRegex(country) {
    return this.COUNTRY_IBAN_REGEX[country];
  }
}